/* Abe Thiessen store theme.
   Three small jobs, no framework: the mobile menu, the cart quantity
   field, and the product option pickers. Every one of them has a working
   fallback in the markup, so nothing here is load bearing. */
(function () {
  'use strict';

  /* ---- Mobile menu ---- */
  var burger = document.getElementById('burger');
  if (burger) {
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && burger.checked) {
        burger.checked = false;
      }
    });
    Array.prototype.forEach.call(document.querySelectorAll('.nav-links a'), function (link) {
      link.addEventListener('click', function () {
        burger.checked = false;
      });
    });
  }

  /* ---- Cart quantity ----
     Changing a number submits the cart, so an edit is never lost by
     walking away from the Update button. The button still works on its own. */
  Array.prototype.forEach.call(document.querySelectorAll('[data-cart-qty]'), function (input) {
    input.addEventListener('change', function () {
      var form = input.form;
      if (!form) { return; }
      var flag = document.createElement('input');
      flag.type = 'hidden';
      flag.name = 'update';
      flag.value = '';
      form.appendChild(flag);
      form.submit();
    });
  });

  /* ---- Product options ---- */
  var picker = document.querySelector('[data-variant-picker]');
  if (!picker) { return; }

  var variants = readJson(picker.querySelector('[data-variant-data]'));
  var prices = readJson(picker.querySelector('[data-variant-prices]'));
  var selects = Array.prototype.slice.call(picker.querySelectorAll('select[data-option-index]'));
  var idInput = document.querySelector('[data-variant-id]');
  var addButton = document.querySelector('[data-add-button]');
  var addText = document.querySelector('[data-add-text]');
  var priceBox = document.querySelector('[data-price]');
  var productUrl = picker.getAttribute('data-product-url') || '';

  if (!variants || !variants.length || !selects.length || !idInput) { return; }

  selects.forEach(function (select) {
    select.addEventListener('change', update);
  });

  function readJson(element) {
    if (!element) { return null; }
    try {
      return JSON.parse(element.textContent);
    } catch (error) {
      return null;
    }
  }

  function chosen() {
    return selects.map(function (select) { return select.value; });
  }

  function findVariant() {
    var wanted = chosen();
    for (var i = 0; i < variants.length; i += 1) {
      var match = true;
      for (var j = 0; j < wanted.length; j += 1) {
        if (variants[i].options[j] !== wanted[j]) { match = false; break; }
      }
      if (match) { return variants[i]; }
    }
    return null;
  }

  function update() {
    var variant = findVariant();

    if (!variant) {
      if (addButton) {
        addButton.disabled = true;
        if (addText) { addText.textContent = addButton.getAttribute('data-unavailable-label'); }
      }
      return;
    }

    idInput.value = variant.id;

    if (addButton) {
      addButton.disabled = !variant.available;
      if (addText) {
        addText.textContent = variant.available
          ? addButton.getAttribute('data-add-label')
          : addButton.getAttribute('data-sold-label');
      }
    }

    if (priceBox && prices && prices[variant.id]) {
      var money = prices[variant.id];
      priceBox.textContent = '';
      if (money.compare) {
        var was = document.createElement('s');
        was.textContent = money.compare;
        priceBox.appendChild(was);
      }
      var now = document.createElement('span');
      now.textContent = money.price;
      priceBox.appendChild(now);
    }

    if (productUrl && window.history && window.history.replaceState) {
      window.history.replaceState({}, '', productUrl + '?variant=' + variant.id);
    }
  }
})();
